import Vue from 'vue'

const mutations = {
  events: (state, events) => Vue.set(state, 'events', events),
  currentEventId: (state, id) => Vue.set(state, 'currentEventId', id),
  eventSummary: (state, data) => Vue.set(state, 'eventSummary', data)
}

export default mutations
